module.exports = __webpack_public_path__ + "public/StoreIcon/showPwsd.svg?64c46f7e";